import { useCurrentClient } from "@/features/clients/hooks/use-clients";
import { externalAccountKeys } from "@/features/external-accounts/hooks/use-external-accounts";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { IntegrationsAPI } from "../api/integrations";
import type { CheckedIntegration } from "../types";

export const bookingAccountKeys = {
  usage: (clientId: string) => ["booking_accounts", "usage", clientId] as const,
};

/** Check a booking account and keep it; the accounts list is read again after. */
export function useSaveBookingAccount() {
  const clientId = useCurrentClient()?.client?.id || "";
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({
      accountId,
      ...body
    }: {
      integration: CheckedIntegration;
      configuration: Record<string, unknown>;
      unchecked?: boolean;
      accountId?: string;
    }) => IntegrationsAPI.saveBookingAccount(clientId, body, accountId),
    onSuccess: (result) => {
      if (result.account_id) {
        queryClient.invalidateQueries({ queryKey: externalAccountKeys.all });
      }
    },
  });
}

export function useBookingAccountUsage() {
  const clientId = useCurrentClient()?.client?.id || "";
  return useQuery({
    queryKey: bookingAccountKeys.usage(clientId),
    queryFn: () => IntegrationsAPI.bookingAccountUsage(clientId),
    enabled: !!clientId,
    staleTime: 30 * 1000,
  });
}
